// extracted by mini-css-extract-plugin
export var companyLink = "Mission-module--company-link--60743";
export var container = "Mission-module--container--6ad84";
export var externalLink = "Mission-module--external-link--eb1ac";
export var hiring = "Mission-module--hiring--6324b";
export var logo = "Mission-module--logo--e5139";
export var paragraph = "Mission-module--paragraph--6aee6";
export var subtitle = "Mission-module--subtitle--13ddc";